"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13.287 3.958a1 1 0 00-.575-1.916l-10 3c-.95.285-.95 1.63 0 1.916l10 3a1 1 0 00.575-1.916L6.48 6l6.807-2.042zM13 12H3a1 1 0 000 2h10a1 1 0 000-2z"];
//# sourceMappingURL=less-than-or-equal-to.js.map